/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import TargetStage from './target-stage';
import FilterConstants from '../../filter-constants';

export default class FirstOrderTargetStage extends TargetStage {
  order = 1;
  @computed('filter', 'stageFp', 'stageQ', 'gain') get stepResponseSetup() {
    var base = this; // for readability. To know which properties are declared in the base class
    var filter = base.filter;
    var stageFp = base.stageFp;
    var gain = base.gain;
    var result = filter.setupFirstOrderStepResponse(stageFp, gain);
    return result;
  }

  @computed('timeAxis', 'stepResponseSetup') get stepResponseIdeal() {
    var timeAxis = this.timeAxis;
    var stepResponseSetup = this.stepResponseSetup;
    var a = stepResponseSetup.a;
    var b = stepResponseSetup.b;
    var w0 = stepResponseSetup.w0;

    var result = timeAxis.map((timePoint) => {
      var tw0 = -1 * timePoint * w0;
      var res = a - b * Math.exp(tw0);
      return res;
    });

    return result;
  }

  defaultImplementation = FilterConstants.implementationType.firstOrder;
  createAmplitude(fp, Q, gain, frequencyArray) {
    return this.filter.createFirstOrderFilterAmplitude(fp, gain, frequencyArray);
  }
}
